document.addEventListener("DOMContentLoaded", function () {
   const placeholder = document.querySelectorAll("#dynamic-article-placeholder");
   if (placeholder) {
     fetch("/?section_id=hello-text")
      .then(response => response.text())
      .then(html => {
        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        // Extract only the .hello-text-section
        const sectionContent = doc.querySelector(".article-advance-section");
        if (sectionContent) {
          document.getElementById("dynamic-article-placeholder").innerHTML = sectionContent.outerHTML;
          // Now bind the tab events after injecting
          const container = document.getElementById("dynamic-article-placeholder");
          const buttons = container.querySelectorAll(".tab-btn");
          const contents = container.querySelectorAll(".tab-content");

          buttons.forEach(button => {
            button.addEventListener("click", function () {
              buttons.forEach(btn => btn.classList.remove("active"));
              contents.forEach(content => content.classList.remove("active"));
              this.classList.add("active");
              const tabId = this.getAttribute("data-tab");
              container.querySelector(`#${tabId}`).classList.add("active");
            });
          });
        } else {
          console.warn("hello-text-section not found in rendered section");
        }
      })
      .catch(err => console.error("Section load error:", err));
   }
})
 

